import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";

function Product() {
    const {t} = useTranslation();
    const location = useLocation();
    const [pageLanguage, setPageLanguage] = useState(location.pathname.split('').slice(1, 3).join(''));
    let navigate = useNavigate();
    const {catID} = useParams();
    const [pageProduct, setPageProduct] = useState([]);
    
    
    const setPage = () => {
                // if (catID === "Ready-Made-Grommet-Drapery") {
                //     setPageProduct(<Products CatID={catID}/>)
                // } else{
                    navigate("/" + pageLanguage);
                // }
    };
    
    useEffect(() => {
        if(catID!==undefined && catID !=="" && pageLanguage !== "") {
            setPage();
        }
        else{
            navigate("/" + pageLanguage);
        }
    }, [pageLanguage, location.pathname]);
    
    
    return (
        <div className="Custom_Product_page_container">
            {pageProduct}
            <p>No Product</p>
        </div>
    );
}

export default Product;